module.exports = __webpack_public_path__ + "static/media/moderna_cluster.1313a43c.svg";